"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./components/create-report-360/create-report-360.controller");
var create_report_360_html_1 = __importDefault(require("./components/create-report-360/create-report-360.html"));
var environment_1 = require("@shared/types/environment");
var download_helper_1 = require("@services/download-helper");
var override_utils_1 = require("@services/overrides/override-utils");
var category_utils_1 = require("@shared/utils/category-utils");
var report_1 = require("@shared/types/report");
var feature_flipper_1 = require("@shared/constants/feature-flipper");
var CUSTOM = 'Custom';
var FIELDS_DENYLIST = [
    'Q_TS_PID',
    'Q_TS_RE_PID',
    'Q_TS_PID',
    'Q_TS_ID',
    'Q_TS_UNSOL',
    'Q_TS_RS'
];
var EXPORT_ERRORS = ['UNEXPECTED_DATA_ERROR'];
var WIDGET_LIMIT_FOR_BRANDS_WITH_EXCEPTION = 1500;
var DEFAULT_WIDGET_LIMIT = 500;
var categoryUtils = new category_utils_1.CategoryUtils(report_1.REPORT_TYPE.TS);
(function (module) {
    'use strict';
    module.service('pr360Override', [
        'prOverrideRegister',
        'pr.OVERRIDE_EVENTS',
        '$filter',
        '$injector',
        '$q',
        'pr.CUSTOM_FILTER_FIELDS',
        'rsEnvironment',
        function (registerOverride, OVERRIDE_EVENTS, $filter, $injector, $q, CUSTOM_FILTER_FIELDS, env) {
            var translate = $filter('translate');
            var DISABLED_WIDGETS = ['eng.heatmap'];
            var overrideUtils = new override_utils_1.OverrideUtils($filter, $injector);
            var getWidgetLimit = function () {
                var _a;
                var shouldIncreaseWidgetLimit = (_a = env.get(environment_1.ENV_VARS.FEATURES)) === null || _a === void 0 ? void 0 : _a[feature_flipper_1.FEATURES.INCREASE_360_WIDGET_COUNT_LIMIT];
                return shouldIncreaseWidgetLimit ? WIDGET_LIMIT_FOR_BRANDS_WITH_EXCEPTION : DEFAULT_WIDGET_LIMIT;
            };
            /* -------------------------------------------------------------- */
            // constants
            registerOverride(OVERRIDE_EVENTS.CONFIG_FLAGS, _.constant({
                disableReportCreation: true,
                disableSharing: true,
                disableWeighting: true,
                disableWidgetExports: true,
                enableDynamicTranslations: true,
                enablePercentileMetric: true,
                shouldHaveRaterDisplayLogic: true,
                shouldHave360DisplayLogic: true,
                shouldUseUserLanguage: true,
                widgetCountLimit: getWidgetLimit()
            }));
            registerOverride(OVERRIDE_EVENTS.NO_REPORTS_MESSAGE, _.constant('PR.NO_SUBJECT_REPORT_MESSAGE'));
            registerOverride(OVERRIDE_EVENTS.CREATE_REPORT_CONTROLLER, _.constant('prCreateReport360Controller'));
            registerOverride(OVERRIDE_EVENTS.CREATE_REPORT_TEMPLATE, _.constant(create_report_360_html_1.default));
            /* -------------------------------------------------------------- */
            // functions
            registerOverride(OVERRIDE_EVENTS.VALIDATE_IMPORTED_CONTAINER_DEF, function (containerDef) {
                if (containerDef.product !== 'printed-reports-360') {
                    var errorMessage = translate('PR.IMPORT_ERROR_360_QRF_REQUIRED');
                    return { errorMessage: errorMessage };
                }
                return containerDef;
            });
            registerOverride(OVERRIDE_EVENTS.FILTERS_CLIENT_FIELDSET_DEF, function (fieldsetDef) {
                // Inject menuService here to avoid circular dependency
                var personMetadataMenuService = $injector.get('prPersonMetadataMenuService');
                var isCustomPresent = _.some(fieldsetDef.fieldSetView, function (view) {
                    return view.type === CUSTOM;
                });
                if (isCustomPresent) {
                    // fieldset already modified
                    return fieldsetDef;
                }
                _.remove(fieldsetDef.fieldSetView, function (item) {
                    return _.includes(FIELDS_DENYLIST, item.fieldId);
                });
                // we do not support filtering on category fields
                var fieldset = { definition: fieldsetDef };
                _.remove(fieldsetDef.fieldSetView, function (item) {
                    return categoryUtils.isCategoryField(item.fieldId, fieldset);
                });
                // Add fake field to fieldset so that "Evaluation Scope" shows
                // in the field dropdown in the filter modal
                fieldsetDef.fieldSetView.push({
                    description: translate('Evaluation Scope'),
                    fieldId: CUSTOM_FILTER_FIELDS.EVAL_SCOPE,
                    name: '',
                    type: CUSTOM,
                    meta: {
                        fullDescription: '',
                        fullType: CUSTOM,
                        iconClass: '',
                        sourceId: CUSTOM
                    }
                });
                // Add fake field to fieldset so that "Relationship" shows
                // in the field dropdown in the filter modal
                fieldsetDef.fieldSetView.push({
                    description: translate('Relationship'),
                    fieldId: 'Q_TS_RS',
                    name: '',
                    type: CUSTOM,
                    meta: {
                        fullDescription: '',
                        fullType: CUSTOM,
                        iconClass: '',
                        sourceId: CUSTOM
                    }
                });
                fieldsetDef.fieldSetView.push({
                    description: translate('Filter by Unsolicited Evaluations'),
                    fieldId: 'Q_TS_UNSOL',
                    name: '',
                    type: CUSTOM,
                    meta: {
                        fullDescription: '',
                        fullType: CUSTOM,
                        iconClass: '',
                        sourceId: CUSTOM
                    }
                });
                return personMetadataMenuService.addMenus(fieldsetDef.fieldSetView)
                    .then(function (updatedFieldSetView) {
                    fieldsetDef.fieldSetView = updatedFieldSetView;
                    return fieldsetDef;
                });
            });
            registerOverride(OVERRIDE_EVENTS.HEADER_OPTIONS, function (options) {
                var activeSurveyId = (options.headerOptions || {}).activeSurveyId;
                var activeProjectId = (options.headerOptions || {}).activeProjectId;
                var pageId = 'NewEditSubjectReports';
                return {
                    pageId: pageId,
                    headerOptions: {
                        activeSuperTabId: 'ProjectsSection',
                        activeSectionTabId: 'ReportsEI',
                        activeSubTabId: pageId,
                        projectType: '360',
                        activeProduct: 'ThreeSixty',
                        activeSurveyId: activeSurveyId,
                        activeProjectId: activeProjectId,
                        isEIAdmin: 1
                    },
                    context: {
                        resourceId: activeProjectId,
                        resourceType: _.get(options, 'headerOptions.projectType', 'ThreeSixtyProject'),
                        subresourceId: activeSurveyId,
                        subresourceType: 'Survey',
                        contextType: 'Project'
                    }
                };
            });
            registerOverride(OVERRIDE_EVENTS.PIPED_TEXT_MENU, function (menu) {
                var PipedTextThreeSixtyMenu = $injector.get('prPipedTextThreeSixtyMenuService');
                var threeSixtyMenu = new PipedTextThreeSixtyMenu();
                return threeSixtyMenu.getMenu().then(function (threeSixtyMenu) {
                    menu.items.push({
                        label: translate('PIPED_TEXT.360_FIELDS'),
                        submenu: {
                            items: threeSixtyMenu
                        }
                    });
                    return menu;
                });
            });
            registerOverride(OVERRIDE_EVENTS.ROUTES, function (routes) {
                routes.MONOLITH_BASE_URL = '/EX/ReportsEI/Ajax/';
                routes.SOURCES = routes.THREE_SIXTY_SERVICE + 'sources/';
                return routes;
            });
            registerOverride(OVERRIDE_EVENTS.FOLDER_API_OPTIONS, function (projectParams) {
                projectParams = { include: ['EX'] };
                return projectParams;
            });
            registerOverride(OVERRIDE_EVENTS.THROW_FAILED_EXPORTS, function (widgetStatusAndTypes) {
                // Immediately fail exports where widgets error out. The error
                // is caught and loggedby GE, which will return an error response
                var widgetStatuses = widgetStatusAndTypes.status;
                var widgetTypes = widgetStatusAndTypes.types;
                var statuses = _.values(widgetStatuses);
                var hasExportError = _.difference(statuses, EXPORT_ERRORS).length !== statuses.length;
                if (hasExportError) {
                    var dataErrorWidgets = _.filter(_.keys(widgetStatuses).map(function (widgetId) {
                        if (_.includes(EXPORT_ERRORS, widgetStatuses[widgetId])) {
                            return {
                                widgetId: widgetId,
                                widgetStatus: widgetStatuses[widgetId],
                                widgetType: widgetTypes[widgetId]
                            };
                        }
                    }));
                    throw new Error(download_helper_1.UNEXPECTED_WIDGET_ERRORS + ": " + JSON.stringify(dataErrorWidgets));
                }
            });
            registerOverride(OVERRIDE_EVENTS.DOWNLOAD_OPTIONS, function (options) {
                return __assign({ checkExportValidity: true }, options);
            });
            registerOverride(OVERRIDE_EVENTS.FAIL_EXPORT_ON_TIMEOUT, function () {
                return {
                    shouldFailExport: true
                };
            });
            registerOverride(OVERRIDE_EVENTS.IMAGE_POSITIONS, function (imagePositions) {
                // https://qualtrics.atlassian.net/browse/REP-5418
                return _.omit(imagePositions, 'fill');
            });
            registerOverride(OVERRIDE_EVENTS.INSERT_MENU, function (menu) {
                overrideUtils.removeDisabledWidgets(menu, DISABLED_WIDGETS);
                overrideUtils.removeDisabledFields(menu, DISABLED_WIDGETS);
                return menu;
            });
            registerOverride(OVERRIDE_EVENTS.SWITCH_OPTIONS, function (switchOptions) {
                overrideUtils.removeItems(switchOptions, function (item) {
                    return _.includes(DISABLED_WIDGETS, item);
                });
                return switchOptions;
            });
            registerOverride(OVERRIDE_EVENTS.WIDGET_CONFIG_INIT, function (data) {
                overrideUtils.updateInitWidgetConfig(data, DISABLED_WIDGETS);
                return data;
            });
            registerOverride(OVERRIDE_EVENTS.TRANSFORM_GRID_RESPONSE, function (data) {
                var response = data.response, options = data.options;
                if (options.breakout &&
                    options.breakout.fieldId &&
                    options.breakout.fieldId === CUSTOM_FILTER_FIELDS.RELATIONSHIP) {
                    var ThreeSixtyRelationshipsService = $injector.get('prThreesixtyRelationshipsService');
                    return ThreeSixtyRelationshipsService.getAllRelationshipTranslations().then(function (translations) {
                        if (translations) {
                            return {
                                response: __assign(__assign({}, response), { relationshipTranslations: translations }),
                                options: options
                            };
                        }
                        return data;
                    });
                }
                else {
                    return $q.resolve(data);
                }
            });
            registerOverride(OVERRIDE_EVENTS.ADD_BREAKOUT_HEADERS, function (state) {
                var responses = _.get(state, 'data[0].data');
                var relationshipTranslations = _.get(state, 'data[0].relationshipTranslations');
                var breakout = _.get(state, 'dataConfig.breakout.fieldId');
                var breakoutHeadersFromState = _.get(state, 'dataConfig.breakoutHeaders');
                if (breakout) {
                    var breakoutHeaders = void 0;
                    if (_.isEmpty(breakoutHeadersFromState) || (breakoutHeadersFromState && breakoutHeadersFromState.length === 0)) {
                        breakoutHeaders = _.map(_.keys(responses), function (breakoutId) {
                            return {
                                key: breakoutId,
                                label: '',
                                defaultLabel: relationshipTranslations ? _.get(relationshipTranslations, breakoutId) : breakoutId
                            };
                        });
                    }
                    else {
                        breakoutHeaders = _.map(breakoutHeadersFromState, function (header) {
                            return __assign(__assign({}, header), { defaultLabel: relationshipTranslations ? _.get(relationshipTranslations, header.key) : header.defaultLabel });
                        });
                    }
                    return __assign(__assign({}, state), { dataConfig: __assign(__assign({}, state.dataConfig), { breakoutHeaders: breakoutHeaders }) });
                }
                return state;
            });
            registerOverride(OVERRIDE_EVENTS.DISABLE_RICH_TEXT, function (options) {
                if (options.widgetType === 'eng.conditionaltext') {
                    options.disable = true;
                }
                return options;
            });
            registerOverride(OVERRIDE_EVENTS.DATA_HTTP_RESPONSE, function (response) {
                var API_ROUTES = $injector.get('pr.API_ROUTES');
                /*
                 * Don't perform piped text processing on non-data requests
                 * or requests that don't specify a person
                 */
                if (!response.config.url.includes(API_ROUTES.DATA)
                    || !response.config.data.dataRequestParams.bulkFieldOptions.value) {
                    return $q.when(response);
                }
                var PipedTextService = $injector.get('prPipedTextService');
                var PipedText = new PipedTextService();
                var pathToResolve = response.config.url.includes('records') ? 'data.fields' : 'data';
                var stringToResolve = JSON.stringify(_.get(response, pathToResolve));
                return $q.when(PipedText.resolvePipedText(stringToResolve)).then(function (result) {
                    return _.set(response, pathToResolve, JSON.parse(result));
                });
            });
        }
    ]);
})(angular.module('qualtrics.pr'));
